import React from "react";
import { User } from "../../types";
import {
  createUser,
  deleteUser,
  getListUsers,
  updateUser,
  userFullName,
  userLabel,
} from "../../api";
import { BasePanel } from "./BasePanel";


export const UsersPanel: React.FC = () => {
  const handleData = (data: Partial<User>) => {
    data.email = data.email?.toLowerCase();
    data.username = data.email?.split("@")[0];
    return data;
  }
  return (
    <BasePanel<User>
      config={{
        title: "Utenti",
        elementName: "Utente",
        getItems: () => getListUsers(),
        createItem: (data) => createUser(handleData(data)),
        updateItem: (id, data) => updateUser(id, handleData(data)),
        deleteItem: (id) => deleteUser(id),
        renderItem: (item) => (
          <div className="py-2 flex flex-col sm:flex-row sm:justify-between sm:items-center">
            <span className="text-sm sm:text-base font-medium mb-1 sm:mb-0 lg:min-w-[400px]">
              {userLabel(item)} - {item.username} {item.can_manage_content ? " [Content]" : ""} {item.can_manage_all ? " [Admin]" : ""}
            </span>
            <span className="text-sm sm:text-base font-medium sm:mb-0">
              {item.email}
            </span>
          </div>
        ),
        getTextField: (item) => userFullName(item),
        fields: [
          { name: "first_name", label: "Nome", type: "text", required: true },
          { name: "last_name", label: "Cognome", type: "text", required: false },
          { name: "email", label: "Email", type: "text", required: true },
          { name: "can_manage_content", label: "Permesso di gestione contenuti", type: "checkbox" },
          { name: "can_manage_all", label: "Permesso di Admin", type: "checkbox" },
        ],
      }}
    />
  )
}